// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__340cv","right":"Footer_right__g5JtK","buttons":"Footer_buttons__757s3"};